export default __webpack_public_path__ + "static/media/img-0625-moldova-full-face.343695c4.png";